/* eslint-disable  */
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Form, Spin } from 'antd';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import editIcon from 'assets/images/table-icons/edit_green.svg';

import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { toast } from 'react-toastify';
import { toastConfig } from 'config';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import { useLocation, useNavigate } from 'react-router-dom';
// import { MemoizedLeaseTable } from '../MemoizedComponents';
// import CardAccordion from '../CardAccordion';
// import LeaseTable from '../../leaseRecodTable';
import { useGetQueryV3Mutation } from 'store/features/api/graphSlice';
import { useSelector } from 'react-redux';
import { useIdentityBulkMutation } from 'store/features/process/processApi';
import { encodeQueryParamData } from 'utils/utils';
import { stateUpdater } from '../LeaseUtils/helper';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import RestorePageOutlinedIcon from '@mui/icons-material/RestorePageOutlined';
dayjs.extend(utc);

const ActionButtons = forwardRef(({ screen, handleCreation, handleUpdate, viewData, dataFullyLoaded = false, hasCCAssigned, hasGlAssigned }, ref) => {
	// const leaseProcessCode = useSelector((state) => state.lease.leaseProcessCode);
	const { state } = useLocation();
	const form = Form.useFormInstance();
	// const statusData = viewData?.parkedData ? viewData?.parkedData : viewData?.data;
	// console.log(viewData,'statusData123');
	const [formState, setFormState] = useState({
		showActiveDeactiveModal: false,
		showFormSubmitModal: false,
		submitPayload: null,
		modalData: {
			head: state?.processName ?? '',
			label: 'Do you want to proceed?',
		},
	});
	const updateFormState = stateUpdater(setFormState);
	const [draftSubmit, { isSuccess: isDraftSubmitSuccess }] = useIdentityBulkMutation();
	const handleSubmitClick = () => {
		const payloadData = [viewData?._id];
		// const convertJson = JSON.stringify(payloadData);
		// const convertBase64 = btoa(convertJson);
		const formattedPayload = {
			_id: payloadData,
			operation: 'submit-draft-bulk',
			processCode: state?.processCode,
			suffixCode: '',
		};

		// draftSubmit(formattedPayload)
		updateFormState('showFormSubmitModal', true);
		updateFormState('modalData.head', 'Confirmation');
		updateFormState('modalData.label', 'Do you want to submit this lease record?');

		updateFormState('submitPayload', formattedPayload);
	};
	const handleModalSubmit = async () => {
		await draftSubmit(formState?.submitPayload);
	};
	const setShowFormSubmitModal = (value) => {
		updateFormState('showFormSubmitModal', value);
	};
	const [
		getLeaseTableData,
		{
			data: leaseControlDataV3,
			// isLoading: isLeaseTableDataLoading,
		},
	] = useGetQueryV3Mutation();
	const [IdentityBulk, { isSuccess: isCaseSuccess, isError: isCaseError }] = useIdentityBulkMutation();

	const [isDraft, setIsDraft] = useState(false);
	const [isModifyButtonDisabled, setIsModifyButtonDisabled] = useState(false);

	const [flag, setFlag] = useState({
		check: 0,
		editable: 0,
	});

	const theme = useTheme();

	const navigate = useNavigate();

	const [isEditDisabled, setIsEditDisabled] = useState(true);
	const { creatorOrganizationId } = useSelector((state) => state.profile.profileData);
	const companyCode = creatorOrganizationId;
	// const memoizedStatusData = useMemo(() => {
	// 	return viewData?.parkedData || viewData?.data;
	// }, [viewData?.parkedData, viewData?.data]);
	const [
		getLeaseData,
		{
			// data: leaseControlData,
			isLoading: isLeaseControlDataLoading,
		},
	] = useSendControlDataMutation();

	// const memoizedLeaseControlData = useMemo(() => {
	// 	if (screen?.toLowerCase() === 'view') {
	// 		return leaseControlDataV3?.results ?? [];
	// 	}
	// 	if (flag?.check === 0) {
	// 		return leaseControlDataV3?.results ?? [];
	// 	}
	// 	return leaseControlData?.responseData ?? [];
	// }, [flag?.check, leaseControlDataV3?.results, leaseControlData?.responseData]);
	// Determine the appropriate handlers and flags based on screen mode
	const handleSubmitAction = () => {
		if (screen === 'CREATE') {
			if (handleCreation) handleCreation();
		} else {
			if (handleUpdate) handleUpdate();
		}
	};
	const isLeaseLifeCycleOver = () => {
		const currentDate = dayjs();
		const leaseEndDate = dayjs(form.getFieldValue('leaseEndDate'));

		return currentDate.isAfter(leaseEndDate);
	};

	const [areAllRecordsRecorded, setAreAllRecordsRecorded] = useState(false);
	const [showClosedModal, setShowClosedModal] = useState(false);
	const [modalData, setModalData] = useState({
		head: state?.processName ?? '',
		label: 'Do you want to proceed?',
	});
	const [activeDeactiveSubmitData, setActiveDeactiveSubmitData] = useState(null);

	const handleSingleLeaseDeactivate = (status) => {
		if (status === 'Closed') {
			setModalData({
				head: state?.processName ?? 'Lease Record',
				action: status,
				label: <p>Do you want to close this lease record?</p>,
			});
		}
		if (status === 'Reopened') {
			setModalData({
				head: state?.processName ?? 'Lease Record',
				action: status,
				label: <p>Do you want to re-open this lease record?</p>,
			});
		}

		const singleLeasePayload = [{ _id: state._id }];
		setActiveDeactiveSubmitData(singleLeasePayload);
		setShowClosedModal(true);
	};

	const modalSubmitHandler = () => {
		if (modalData?.action === 'Closed') {
			const payload = {
				_id: activeDeactiveSubmitData.map((item) => item._id),
				operation: 'activate-bulk',
				processCode: state?.processCode,
				activationStatus: 'Closed',
			};
			IdentityBulk(payload);
		} else if (modalData?.action === 'Reopened') {
			const payload = {
				_id: activeDeactiveSubmitData.map((item) => item._id),
				operation: 'activate-bulk',
				processCode: state?.processCode,
				activationStatus: 'Reopened',
			};
			IdentityBulk(payload);
		}
		setShowClosedModal(false);
	};

	useEffect(() => {
		if (isCaseSuccess) {
			toast.success('Success! Lease status updated successfully', toastConfig);
			// const queryParamData = encodeQueryParamData({ processCode: state?.processCode });
			navigate(-1);
		} else if (isCaseError) {
			toast.error('Failed! Status update not completed', toastConfig);
			setShowClosedModal(false);
		}
	}, [isCaseSuccess, isCaseError]);

	const queryV3Loader = async () => {
		if (screen !== 'CREATE') {
			const version = String(viewData?.data?.version);

			if (
				version &&
				version !== 'null' &&
				version !== 'undefined' &&
				companyCode
				// (viewData?.activationStatus?.toLowerCase() === 'active' ||
				// 	viewData?.activationStatus?.toLowerCase() === 'closed' ||
				// 	viewData?.activationStatus?.toLowerCase() === 're-open')
			) {
				await getLeaseTableData({
					companyCode,
					fieldCodes: ['companyCode', 'identityRecordIdString', 'version'],
					fieldValues: [companyCode, state?._id, version],
					name: 'leaseSchedulesOnVersion-v6',
				});
			}
		}
	};
	useEffect(() => {
		if (isDraftSubmitSuccess) {
			navigate(-1);
		}
	}, [isDraftSubmitSuccess]);

	const isEditable = () => {
		const data = leaseControlDataV3?.results;

		if (!data) return false;
		const sequence = form.getFieldValue('modificationSequence');
		// if (sequence === 0) return false;

		const changeTableData = form.getFieldValue('changes');
		const lastEffectiveDate =
			sequence === 0
				? changeTableData?.[changeTableData?.length - 1]?.inputChangeEffectiveDate
				: changeTableData?.[changeTableData?.length - 2]?.inputChangeEffectiveDate;
		if (!lastEffectiveDate) return false;

		// Get the current date at start of day
		const currentDate = dayjs().startOf('day');
		// Parse the lastEffectiveDate at start of day
		const lastEffective = dayjs(lastEffectiveDate);
		// Check if lastEffective is valid
		if (!lastEffective.isValid()) {
			console.error('Invalid lastEffectiveDate:', lastEffectiveDate);
			return false;
		}
		const lastEffectiveStartOfDay = lastEffective.startOf('day');
		// Filter data to include only records within the date range (inclusive)
		const recordsInRange = data?.filter((item) => {
			// Check if item and item.date exist
			if (!item?.date) {
				console.warn('Missing date for item:', item);
				return false;
			}

			const itemDate = dayjs(item.date);

			// Check if itemDate is valid
			if (!itemDate.isValid()) {
				console.warn('Invalid date:', item.date);
				return false;
			}

			const itemDateStartOfDay = itemDate.startOf('day');

			// Using basic comparison instead of isSameOrAfter/isSameOrBefore
			return itemDateStartOfDay.valueOf() >= lastEffectiveStartOfDay.valueOf() && itemDateStartOfDay.valueOf() <= currentDate.valueOf();
		});
		let allMatch = true;
		// Check if all records in range have processStatus "returned" or ""
		if (hasCCAssigned && hasGlAssigned) {
			allMatch = recordsInRange?.every((item) => item?.processStatus === 'Returned' || item?.processStatus === '');
		}

		return allMatch;
	};
	useEffect(() => {
		queryV3Loader();
		setIsDraft(viewData?.activationStatus?.toLowerCase() === 'draft');
		setIsModifyButtonDisabled(viewData?.activationStatus?.toLowerCase() === 'closed');
	}, [dataFullyLoaded, viewData]);
	const handleDataLoading = async () => {
		let payloadData = {};
		const formData = form.getFieldsValue();
		if (screen?.toLowerCase() === 'create') {
			payloadData = {
				advanceAmount: formData?.advanceAmount,
				leaseTerm: formData?.leaseTerm,
				discountRate: formData?.initialDiscountRate,
				startYear: String(formData?.leaseStartDate?.year()),
				escalation: 0,
				startMonth: String(formData?.leaseStartDate?.month() + 1),
				paymentFrequency: formData?.paymentFrequency,
				paymentTime: formData?.paymentModality,
				advanceDuration: formData?.advanceAmounts?.filter((item) => item !== 0)?.length,
				startDay: String(formData?.leaseStartDate?.date()),
				upfrontLeasePayment: formData?.upfrontLeasePayment,
				initialDirectCost: formData?.initialDirectCost,
				securityDeposit: formData?.securityDeposit,
				endOfFinancialYear: formData?.endOfFinancialYear,
				advanceAmounts: formData?.advanceAmounts,
				grossRents: formData?.grossRents,
				grossRent: 0,
				changes: [],
			};
			const convertJson = JSON.stringify(payloadData);
			const convertBase64 = btoa(convertJson);
			const formattedPayload = {
				data: convertBase64,
				processCode: state.processCode,
				scriptName: 'lease-controller-lease',
				payloadData: payloadData,
			};
			try {
				await getLeaseData(formattedPayload);
			} catch (error) {
				return;
			}
		} else {
			if (dataFullyLoaded) {
				// const currentChangesLength = form.getFieldValue('changes')?.length;
				const effectiveChanges = form.getFieldValue('changes')?.filter((_, index) => index !== 0);

				// Normalize array lengths by ensuring inputChangeAdvanceAmounts has same length as inputChangeGrossRents
				const normalizedEffectiveChanges = effectiveChanges.map((item) => {
					const grossRentsLength = item?.inputChangeGrossRents?.length || 0;
					const advanceAmountsLength = item?.inputChangeAdvanceAmounts?.length || 0;

					// If advanceAmounts array is shorter than grossRents array, pad with zeros
					if (grossRentsLength > advanceAmountsLength && Array.isArray(item?.inputChangeGrossRents)) {
						const paddedAdvanceAmounts = [...(item?.inputChangeAdvanceAmounts || [])];
						// Add zeros to match the length
						while (paddedAdvanceAmounts.length < grossRentsLength) {
							paddedAdvanceAmounts.push(0);
						}
						return {
							...item,
							inputChangeAdvanceAmounts: paddedAdvanceAmounts,
						};
					}
					return item;
				});

				payloadData = {
					advanceAmount: formData?.changes?.[0]?.inputChangeAdvanceAmounts?.reduce(
						(accumulator, currentValue) => accumulator + currentValue,
						0
					),
					leaseTerm: formData?.changes?.[0]?.inputChangeLeaseTerm,
					discountRate: formData?.changes?.[0]?.inputChangeDiscountRate,
					startDay: String(formData?.leaseStartDate?.date()),
					startMonth: String(formData?.leaseStartDate?.month() + 1),
					startYear: String(formData?.leaseStartDate?.year()),
					escalation: 0,
					paymentFrequency: formData?.changes?.[0]?.paymentFrequency,
					paymentTime: formData?.changes?.[0]?.paymentTime,
					advanceDuration: formData?.changes?.[0]?.inputChangeAdvanceAmounts?.filter((item) => item !== 0)?.length,
					upfrontLeasePayment: formData?.changes?.[0]?.upfrontLeasePayment,
					initialDirectCost: formData?.changes?.[0]?.initialDirectCost,
					securityDeposit: formData?.securityDeposit,
					endOfFinancialYear: formData?.endOfFinancialYear,
					advanceAmounts: formData?.changes?.[0]?.inputChangeAdvanceAmounts,
					grossRents: formData?.changes?.[0]?.inputChangeGrossRents,
					changes: normalizedEffectiveChanges.map((item, index) => {
						if (index === normalizedEffectiveChanges.length - 1) {
							return {
								...item,
								upfrontLeasePayment: formData?.upfrontLeasePayment,
								initialDirectCost: formData?.initialDirectCost,
								securityDeposit: formData?.securityDeposit,
							};
						}
						return {
							...item,
						};
					}),
					grossRent: 0,
				};

				// Also normalize the main advanceAmounts array if needed
				if (
					Array.isArray(payloadData.grossRents) &&
					Array.isArray(payloadData.advanceAmounts) &&
					payloadData.grossRents.length > payloadData.advanceAmounts.length
				) {
					const paddedAdvanceAmounts = [...payloadData.advanceAmounts];
					while (paddedAdvanceAmounts.length < payloadData.grossRents.length) {
						paddedAdvanceAmounts.push(0);
					}
					payloadData.advanceAmounts = paddedAdvanceAmounts;
				}
			}

			const convertJson = JSON.stringify(payloadData);

			const convertBase64 = btoa(convertJson);
			const formattedPayload = {
				data: convertBase64,
				processCode: state?.processCode,
				scriptName: 'lease-controller-lease',
				payloadData: payloadData,
			};

			try {
				await getLeaseData(formattedPayload);
			} catch (error) {
				console.error('Error in data loading:', error);
			}
		}
	};
	useImperativeHandle(ref, () => ({
		handleDataLoading,
		flag,
		setFlag,
		queryV3Loader,
	}));
	// useEffect(() => {
	// 	// Only run queryV3Loader when specific conditions are met
	// 	if ((screen?.toLowerCase() === 'view' || screen?.toLowerCase() === 'edit') && dataFullyLoaded) {
	// 		queryV3Loader();
	// 	}
	// }, [screen, dataFullyLoaded, viewData?._id, viewData?.version]);

	useEffect(() => {
		const isEditableData = isEditable();
		if (leaseControlDataV3?.results?.length > 0) {
			setIsEditDisabled(!isEditableData);
		}
	}, [JSON.stringify(leaseControlDataV3?.results)]);

	useEffect(() => {
		if (Array.isArray(leaseControlDataV3?.results)) {
			const isAllRecordsRecorded = leaseControlDataV3?.results?.every((item) => item?.processStatus === 'Recorded');

			setAreAllRecordsRecorded(isAllRecordsRecorded);
		}
	}, [JSON.stringify(leaseControlDataV3?.results)]);

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				gap: '4px',
				pt: '15px',
				flexDirection: 'column',
			}}
		>
			<Spin spinning={isLeaseControlDataLoading}>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						gap: '4px',
						pt: '15px',
						flexDirection: 'row',
					}}
				>
					{screen !== 'VIEW' ? (
						<Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
							<Button
								type="primary"
								onClick={handleSubmitAction}
								style={{
									backgroundColor: theme.palette.lynTheme.main,
									marginBottom: 10,
									marginTop: 10,
								}}
							>
								{screen === 'CREATE' ? 'Submit' : 'Update'}
							</Button>
						</Box>
					) : (
						// VIEW mode buttons
						<Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
							{viewData && (
								<>
									{/* <Button
										type="primary"
										style={{
											fontSize: '13px',
											fontWeight: '500',
											borderRadius: '6px',
											marginRight: '3px',
											display: 'flex',
											alignItems: 'center',
											gap: '6px',
											...(viewData?.history?.length === 0 ? { backgroundColor: '#6c757d' } : {}),
										}}
										onClick={(e) => {
											e.stopPropagation();
											if (selectHistory) {
												selectHistory({ ...viewData, ...viewData?.data, id: viewData?._id });
											} else if (viewData?.selectHistory) {
												viewData.selectHistory({ ...viewData, ...viewData?.data, id: viewData?._id });
											}
										}}
									>
										<img src={viewData?.history?.length > 1 ? pdfIcon : pdfIconDisable} width={16} height={16} alt="view" />
										Change Log
									</Button> */}
									{!isDraft ? (
										<Button
											// disabled={viewData?.activationStatus?.toLowerCase() === 'closed'}
											style={{
												display: 'flex',
												alignItems: 'center',
												fontSize: '13px',
												fontWeight: '500',
												borderRadius: '6px',
												margin: '1px',
												marginLeft: '6px',
											}}
											icon={<img src={editIcon} width={16} height={16} alt="edit" />}
											onClick={(e) => {
												e.stopPropagation();
												if (navigate && state) {
													navigate('/static/lease-record-management-v6/edit', {
														state: state,
													});
												}
											}}
										>
											Modify
										</Button>
									) : (
										<Button
											// disabled={viewData?.activationStatus?.toLowerCase() === 'closed'}
											style={{
												display: 'flex',
												alignItems: 'center',
												fontSize: '13px',
												fontWeight: '500',
												borderRadius: '6px',
												margin: '1px',
												marginLeft: '6px',
											}}
											icon={<img src={editIcon} width={16} height={16} alt="edit" />}
											onClick={handleSubmitClick}
										>
											Submit
										</Button>
									)}
									{!isEditDisabled && (
										<Button
											style={{
												display: 'flex',
												alignItems: 'center',
												fontSize: '13px',
												fontWeight: '500',
												borderRadius: '6px',
												margin: '1px',
												marginLeft: '6px',
											}}
											icon={<img src={editIcon} width={16} height={16} alt="edit" />}
											onClick={(e) => {
												e.stopPropagation();
												if (navigate && state) {
													navigate('/static/lease-record-management-v6/revise', {
														state: state,
													});
												}
											}}
										>
											Edit
										</Button>
									)}

									{areAllRecordsRecorded &&
										isLeaseLifeCycleOver() &&
										(viewData?.activationStatus !== 'Closed' ? (
											<Button
												style={{
													display: 'flex',
													alignItems: 'center',
													fontSize: '13px',
													fontWeight: '500',
													borderRadius: '6px',
													margin: '1px',
													marginLeft: '6px',
												}}
												icon={<AssignmentTurnedInOutlinedIcon />}
												onClick={(e) => {
													e.stopPropagation();
													handleSingleLeaseDeactivate('Closed');
												}}
											>
												Close
											</Button>
										) : (
											<Button
												style={{
													display: 'flex',
													alignItems: 'center',
													fontSize: '13px',
													fontWeight: '500',
													borderRadius: '6px',
													margin: '1px',
													marginLeft: '6px',
												}}
												icon={<RestorePageOutlinedIcon />}
												onClick={(e) => {
													e.stopPropagation();
													handleSingleLeaseDeactivate('Reopened');
												}}
											>
												Reopen
											</Button>
										))}
								</>
							)}
						</Box>
					)}
				</Box>
				{/* <Spin spinning={isLeaseTableDataLoading || isLeaseControlDataLoading}>
					{memoizedLeaseControlData?.length > 0 && (
						<CardAccordion
							title="Lease Schedule"
							customHeaderSX={{
								fontSize: '16px',
								backgroundColor: '#e1f0ff !important',
								p: '10px',
							}}
							typographySX={{ fontSize: '16px !important' }}
							darkTitle={true}
						>
							<LeaseTable leaseControlData={memoizedLeaseControlData} screen={screen} />
						</CardAccordion>
					)}
				</Spin> */}
			</Spin>
			{showClosedModal && (
				<ComptrollerConfirmModal
					showModal={showClosedModal}
					setShowModal={setShowClosedModal}
					modalData={modalData}
					handleSubmit={modalSubmitHandler}
				/>
			)}
			{formState?.showFormSubmitModal && (
				<ComptrollerConfirmModal
					showModal={formState?.showFormSubmitModal}
					modalData={formState?.modalData}
					setShowModal={setShowFormSubmitModal}
					handleSubmit={handleModalSubmit}
				/>
			)}
		</Box>
	);
});

ActionButtons.displayName = 'ActionButtons';

export default ActionButtons;
